import { render, staticRenderFns } from "./RankingBadge.vue?vue&type=template&id=068572a9&"
import script from "./RankingBadge.vue?vue&type=script&lang=ts&"
export * from "./RankingBadge.vue?vue&type=script&lang=ts&"
import style0 from "./RankingBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports